import { LandingPage17xvcovc6b4n0 as LandingPage } from './LandingScreen.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  AttendancePeriodsListPagekcmctzhabmp9 as AttendancePeriodsListPage,
  SortOption1cigvg09nc86u as SortOption,
} from './attendance/AttendancePeriodsListPage.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_DefaultUriFormat2bqsbberx5mh8 as get_DefaultUriFormat } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/serialization.mjs';
import { AttendancePeriodFilters2ya4mm5gzi7ou as AttendancePeriodFilters } from './attendance/AttendancePeriodFilters.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1i4e9ym37oxmo as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  CareProgramTemplatesListPage3j0tqz0uh3p6c as CareProgramTemplatesListPage,
  SortOption2n6ez4xp6e0es as SortOption_0,
} from './rates/CareRateTemplatesListPage.mjs';
import { CareProgramTemplateFilters33ni83g3dp3j2 as CareProgramTemplateFilters } from './rates/CareProgramTemplateFilters.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { NewCareProgramTemplatePage9f7vghfhsbym as NewCareProgramTemplatePage } from './rates/NewCareRateTemplatePage.mjs';
import {
  ChildrenListPage2q8x8yakd8gse as ChildrenListPage,
  SortOption2cy91nan8ja9 as SortOption_1,
} from './children/ChildrenListPage.mjs';
import { ChildFilters2g5230wjkae0g as ChildFilters } from './children/ChildFilters.mjs';
import { CloseOutPagesekceysksiq3 as CloseOutPage } from './closeout/CloseOutPage.mjs';
import { YearMonth22nahmknr467s as YearMonth } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import { HomePage3ptt6l367zajb as HomePage } from './HomeScreen.mjs';
import { EmployerCostCalculatorPage3hdtsayh3aqer as EmployerCostCalculatorPage } from './employers/EmployerCostCalculatorPage.mjs';
import {
  EmployersListPage35v89m7b6r55o as EmployersListPage,
  SortOption3c41pcc3ot2up as SortOption_2,
} from './employers/EmployersListPage.mjs';
import { EmployerFilters17o1u8lpnflmp as EmployerFilters } from './employers/EmployerFilters.mjs';
import {
  FamiliesListPage2r5h75kkdixvz as FamiliesListPage,
  SortOption3rzy1xty7kmz2 as SortOption_3,
} from './families/FamilyListPage.mjs';
import { FamilyFilters3iztb6wnntge7 as FamilyFilters } from './families/FamilyFilters.mjs';
import { NewFamilyPageoco5erkooy02 as NewFamilyPage } from './families/NewFamilyPage.mjs';
import {
  FamilyApplicationsListPage36qv7eutg9abf as FamilyApplicationsListPage,
  SortOption1pk0fob8nf099 as SortOption_4,
} from './applications/FamilyApplicationsListPage.mjs';
import { FamilyApplicationFilters22j6eillzfykb as FamilyApplicationFilters } from './applications/FamilyApplicationFilters.mjs';
import { ExcelFormulaLabPage2bthkhkor66sr as ExcelFormulaLabPage } from './ExcelFormulaLab.mjs';
import {
  GrantsListPageastthp822mlu as GrantsListPage,
  SortOptiontkub9ihc4k7q as SortOption_5,
} from './grants/GrantsListPage.mjs';
import { GrantFilters3ul802ikwukwd as GrantFilters } from './grants/GrantFilters.mjs';
import {
  LocationsListPage204x74tlyxper as LocationsListPage,
  SortOption28u5d223wqzoa as SortOption_6,
} from './locations/LocationsListPage.mjs';
import { LocationFilters8pzx7as7uqbu as LocationFilters } from './locations/LocationFilters.mjs';
import { LoginPage29d8dob2fd0ln as LoginPage } from './LoginScreen.mjs';
import {
  NotificationListPagec9eun7x3iu4r as NotificationListPage,
  SortOptiong6pa3ijnod8n as SortOption_7,
} from './NotificationListPage.mjs';
import { NotificationFilters2kj3bq3y0683j as NotificationFilters } from './NotificationFilters.mjs';
import {
  ChildPlacementsListPage3kc05o0qpi5ea as ChildPlacementsListPage,
  SortOption3nijlnh8melpu as SortOption_8,
} from './children/ChildPlacementsListPage.mjs';
import { ChildPlacementFilters8x2p7iwlj5m5 as ChildPlacementFilters } from './children/ChildPlacementFilters.mjs';
import { ProfilePagezfg19fjwgylu as ProfilePage } from './users/ProfilePage.mjs';
import {
  ProviderApplicationsListPagedp7b45wy4hgv as ProviderApplicationsListPage,
  SortOptionz291lvjrf9in as SortOption_9,
} from './applications/ProviderApplicationsListPage.mjs';
import { ProviderApplicationFilters1wezsqw2uahlo as ProviderApplicationFilters } from './applications/ProviderApplicationFilters.mjs';
import {
  ProvidersListPage1qhw10fj2zdjm as ProvidersListPage,
  SortOption2upp3gw0c074b as SortOption_10,
} from './providers/ProvidersListPage.mjs';
import { ProviderFilters3g67cr8we1hwi as ProviderFilters } from './providers/ProviderFilters.mjs';
import { RemittanceTestPage1r728tkqg3lv5 as RemittanceTestPage } from './RemittanceTestScreen.mjs';
import { Conditionlbcfpsbet24r as Condition } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  SingleChildDayfsi906tc8dp6 as SingleChildDay,
  ID1sgzzdpfpwkrm as ID,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import {
  RemittancesListPage22q46xpibhdg4 as RemittancesListPage,
  SortOption340ipm5glu6w6 as SortOption_11,
} from './remittances/RemittancesListPage.mjs';
import { RemittanceFilters1eq211s3cpfnh as RemittanceFilters } from './remittances/RemittanceFilters.mjs';
import { BalanceSheetPage2218um6yj4e9j as BalanceSheetPage } from './reports/BalanceSheetPage.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  DayTotalsPage3tkd9ei9dl3us as DayTotalsPage,
  DayGrouping3jwege0metqlv as DayGrouping,
} from './reports/DayTotalsPage.mjs';
import { ReportFiltersigb451dg4asm as ReportFilters } from './reports/ReportFilters.mjs';
import { SingleDaysPage2w42wjhncrkcq as SingleDaysPage } from './reports/SingleDaysPage.mjs';
import {
  PlacementTotalsPage1pmi1f9h9gb4a as PlacementTotalsPage,
  PlacementGrouping39ofupa5wg0i5 as PlacementGrouping,
} from './reports/PlacementTotalsPage.mjs';
import { SurveyListPage1qf6jxjitzrxe as SurveyListPage } from './surveys/SurveyListPage.mjs';
import { SurveyNewPage2cofqn1wxyvtq as SurveyNewPage } from './surveys/SurveyNewPage.mjs';
import {
  UserListPagefht460rwsun7 as UserListPage,
  SortOption2etp7392zcarg as SortOption_12,
} from './users/UserListPage.mjs';
import { UserFilters22xvptk4l1j94 as UserFilters } from './users/UserFilters.mjs';
import {
  ID14pksykyak8vt as ID_0,
  ID2llykdzmszlol as ID_1,
  IDqqik72jjbpsn as ID_2,
  IDjecfjjw6mot9 as ID_3,
  ID1lyj7m2ox8cp5 as ID_4,
  ID1z61wlmtvxrjn as ID_5,
  IDknm0szoty74n as ID_6,
  ID1m87d1hextx54 as ID_7,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { AttendancePeriodDetailPage2fnxdkx3t2m6k as AttendancePeriodDetailPage } from './attendance/AttendancePeriodDetailPage.mjs';
import {
  ID3j2ictjlq95nd as ID_8,
  ID3lnbkn76l7dgd as ID_9,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { CareProgramTemplateDetailPagec1d9jyccm55e as CareProgramTemplateDetailPage } from './rates/CareRateTemplateDetailPage.mjs';
import { NewCareProgramTemplateDatedPage862e666vii05 as NewCareProgramTemplateDatedPage } from './rates/NewCareRateTemplateDatedPage.mjs';
import { ChildDetailPage3f2al5z4lb3ic as ChildDetailPage } from './children/ChildDetailPage.mjs';
import { NewChildPlacementPage3k697wogz82ti as NewChildPlacementPage } from './children/NewChildPlacementPage.mjs';
import { EmployerDetailPage15t2ca6578ek0 as EmployerDetailPage } from './employers/EmployerDetailPage.mjs';
import { EmployerMonthsPagesopligyz03kb as EmployerMonthsPage } from './employers/EmployerMonthsPage.mjs';
import { NewEmployerRatePagegotlrdlenb2b as NewEmployerRatePage } from './employers/NewEmployerRatePage.mjs';
import { EmployerTransactionsPageanwqvpujplg1 as EmployerTransactionsPage } from './employers/EmployerTransactionsPage.mjs';
import { EmployerTransactionFiltersoi92a4xu2zce as EmployerTransactionFilters } from './employers/EmployerTransactionFilters.mjs';
import { FamilyDetailPage2yycb034kbs09 as FamilyDetailPage } from './families/FamilyDetailPage.mjs';
import {
  ID3eto015dm4eyk as ID_10,
  ID3deomyff8nvpw as ID_11,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/applications.mjs';
import { FamilyApplicationDetailPage3ca1ne4h64yjy as FamilyApplicationDetailPage } from './applications/FamilyApplicationDetailPage.mjs';
import { GrantDetailPage2hh4qttandzm4 as GrantDetailPage } from './grants/GrantDetailPage.mjs';
import { NewGrantRatePagekivqkap2rvng as NewGrantRatePage } from './grants/NewGrantRatePage.mjs';
import { GrantTransactionsPage3anbgmpp83vih as GrantTransactionsPage } from './grants/GrantTransactionsPage.mjs';
import { GrantTransactionFilters1p8m9r9mmhdhp as GrantTransactionFilters } from './grants/GrantTransactionFilters.mjs';
import { LocationRatePagecks6xwyzxx95 as LocationRatePage } from './rates/LocationRatePage.mjs';
import { LocationDetailPage2zka4ek7qyuhq as LocationDetailPage } from './locations/LocationDetailPage.mjs';
import { ChildPlacementDetailPagewfmc55i6s15v as ChildPlacementDetailPage } from './children/ChildPlacementDetailPage.mjs';
import { ProviderApplicationDetailPage2kxg2k1w3bu5h as ProviderApplicationDetailPage } from './applications/ProviderApplicationDetailPage.mjs';
import { ProviderDetailPagemo61e65yggj8 as ProviderDetailPage } from './providers/ProviderDetailPage.mjs';
import { RemittanceDetailPage384df89l74tfl as RemittanceDetailPage } from './remittances/RemittanceDetailPage.mjs';
import { ID3b6wrkk3fpdmq as ID_12 } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import {
  SurveyDetailPage3czjqatyupm6x as SurveyDetailPage,
  SurveyFilters2cjo777kkjhq1 as SurveyFilters,
  SurveyGrouping2hhrlvdnne3oa as SurveyGrouping,
} from './surveys/SurveyDetailPage.mjs';
import { ID2ebczrc12h07k as ID_13 } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { UserDetailPage3cz18tdewf15f as UserDetailPage } from './users/UserDetailPage.mjs';
import { RemittanceReviewPage1y592xgwqobqi as RemittanceReviewPage } from './remittances/RemittanceReviewPage.mjs';
import { AnonymousSurveyPage31h992m9jks1x as AnonymousSurveyPage } from './surveys/AnonymousSurveyPage.mjs';
import { Uuid1zxgztb7abqxx as Uuid } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { SurveyTakePage3k2il0je8ciy as SurveyTakePage } from './surveys/SurveyTakePage.mjs';
import {
  UrlLikePath1l4lcedbwd0yq as UrlLikePath,
  RouteRendered1fij9e8c6nzoq as RouteRendered,
  Routesboifombvgcz7 as Routes,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_AutoRoutes() {
  _init_properties_autoroutes_kt__az6i9l();
  return AutoRoutes;
}
var AutoRoutes;
function AutoRoutes$lambda(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 0))
    return null;
  // Inline function 'kotlin.apply' call
  return new (LandingPage())();
}
function AutoRoutes$lambda_0(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'attendance-periods'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (AttendancePeriodsListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(AttendancePeriodFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption()), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    var tmp$ret$11 = this_5.decodeFromStringMap_zhdvns_k$(tmp$ret$12, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  return this_0;
}
function AutoRoutes$lambda_1(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'care-rate-templates'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (CareProgramTemplatesListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(CareProgramTemplateFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_0()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_2(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'care-rate-templates'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(1) === 'new'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (NewCareProgramTemplatePage())();
}
function AutoRoutes$lambda_3(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'children'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (ChildrenListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(ChildFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_1()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_4(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'close-out'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (CloseOutPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'month')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(YearMonth()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'month', encodedParameters);
    this_0.month_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  return this_0;
}
function AutoRoutes$lambda_5(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'dashboard'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (HomePage())();
}
function AutoRoutes$lambda_6(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'employer-cost-calculator'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (EmployerCostCalculatorPage())();
}
function AutoRoutes$lambda_7(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'employers'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (EmployersListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(EmployerFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_2()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_8(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'families'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (FamiliesListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(FamilyFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_3()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_9(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'families'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(1) === 'new'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (NewFamilyPage())();
}
function AutoRoutes$lambda_10(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'family-applications'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (FamilyApplicationsListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(FamilyApplicationFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_4()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_11(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'formula-lab'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ExcelFormulaLabPage())();
}
function AutoRoutes$lambda_12(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'grants'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (GrantsListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(GrantFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_5()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_13(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'locations'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (LocationsListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(LocationFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_6()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_14(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'login'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (LoginPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'email')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'email', encodedParameters);
    this_0.email_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  return this_0;
}
function AutoRoutes$lambda_15(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'notifications'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (NotificationListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(NotificationFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sortBy')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_7()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sortBy', encodedParameters);
    this_0.sortBy_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_16(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'placements'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (ChildPlacementsListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(ChildPlacementFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_8()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_17(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'profile'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ProfilePage())();
}
function AutoRoutes$lambda_18(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'provider-applications'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (ProviderApplicationsListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(ProviderApplicationFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_9()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_19(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'providers'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (ProvidersListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(ProviderFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_10()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_20(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'remit-test'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (RemittanceTestPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(Condition()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(SingleChildDay()), arrayOf([]), false))]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  return this_0;
}
function AutoRoutes$lambda_21(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'remittances'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (RemittancesListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(RemittanceFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_11()), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    var tmp$ret$11 = this_5.decodeFromStringMap_zhdvns_k$(tmp$ret$12, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  return this_0;
}
function AutoRoutes$lambda_22(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'reports'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(1) === 'balances'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (BalanceSheetPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'start')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(LocalDate()), arrayOf([]), true));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'start', encodedParameters);
    this_0.start_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'endInclusive')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'endInclusive';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(getKClass(LocalDate()), arrayOf([]), true));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.endInclusive_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  return this_0;
}
function AutoRoutes$lambda_23(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'reports'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(1) === 'day-totals'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (DayTotalsPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(ReportFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'groupBy')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(DayGrouping()), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    var tmp$ret$11 = this_5.decodeFromStringMap_zhdvns_k$(tmp$ret$12, 'groupBy', encodedParameters);
    this_0.groupBy_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  return this_0;
}
function AutoRoutes$lambda_24(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'reports'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(1) === 'days'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (SingleDaysPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(ReportFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  return this_0;
}
function AutoRoutes$lambda_25(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'reports'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(1) === 'placement-totals'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (PlacementTotalsPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(ReportFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'groupBy')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(PlacementGrouping()), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    var tmp$ret$11 = this_5.decodeFromStringMap_zhdvns_k$(tmp$ret$12, 'groupBy', encodedParameters);
    this_0.groupBy_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'thenBy')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_8 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_9 = this_8.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_10 = serializer(this_9, createKType(getKClass(PlacementGrouping()), arrayOf([]), true));
    var tmp$ret$15 = isInterface(this_10, KSerializer()) ? this_10 : THROW_CCE();
    var tmp$ret$14 = this_8.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'thenBy', encodedParameters);
    this_0.thenBy_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_26(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'surveys'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (SurveyListPage())();
}
function AutoRoutes$lambda_27(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'surveys'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(1) === 'new'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (SurveyNewPage())();
}
function AutoRoutes$lambda_28(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 1))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'users'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (UserListPage())();
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_1.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$6 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$6);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_2 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = this_2.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(UserFilters()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    var tmp$ret$8 = this_2.decodeFromStringMap_zhdvns_k$(tmp$ret$9, 'filter', encodedParameters);
    this_0.filter_1.valueSet_aujvv6_k$(tmp$ret$8);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = tmp0.decodeFromStringMap_zhdvns_k$(tmp$ret$12, key, encodedParameters);
    this_0.textSearch_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'sort')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SortOption_12()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'sort', encodedParameters);
    this_0.sort_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_0;
}
function AutoRoutes$lambda_29(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'attendance-periods'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_0()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (AttendancePeriodDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_30(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'care-rate-templates'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_8()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (CareProgramTemplateDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_31(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 4))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'care-rate-templates'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'versions'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(3) === 'new'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_8()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (NewCareProgramTemplateDatedPage())(tmp$ret$0);
}
function AutoRoutes$lambda_32(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'children'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_1()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (ChildDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_33(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 4))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'children'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'placements'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(3) === 'new'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_1()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (NewChildPlacementPage())(tmp$ret$0);
}
function AutoRoutes$lambda_34(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'employers'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (EmployerDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_35(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 3))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'employers'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'months'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (EmployerMonthsPage())(tmp$ret$0);
}
function AutoRoutes$lambda_36(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 4))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'employers'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'rates'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(3) === 'new'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (NewEmployerRatePage())(tmp$ret$0);
}
function AutoRoutes$lambda_37(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 3))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'employers'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'transactions'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  var this_2 = new (EmployerTransactionsPage())(tmp$ret$0);
  // Inline function 'kotlin.collections.mapValues' call
  var this_3 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_3.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_3.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$9 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$9);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_4 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = this_4.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(getKClass(EmployerTransactionFilters()), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = this_4.decodeFromStringMap_zhdvns_k$(tmp$ret$12, 'filter', encodedParameters);
    this_2.filter_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0_0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_7 = tmp0_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_8 = serializer(this_7, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_8, KSerializer()) ? this_8 : THROW_CCE();
    var tmp$ret$14 = tmp0_0.decodeFromStringMap_zhdvns_k$(tmp$ret$15, key, encodedParameters);
    this_2.textSearch_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_2;
}
function AutoRoutes$lambda_38(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'families'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_3()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (FamilyDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_39(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'family-applications'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_10()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (FamilyApplicationDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_40(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'grants'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_4()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (GrantDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_41(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 4))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'grants'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'rates'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(3) === 'new'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_4()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (NewGrantRatePage())(tmp$ret$0);
}
function AutoRoutes$lambda_42(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 3))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'grants'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'transactions'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_4()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  var this_2 = new (GrantTransactionsPage())(tmp$ret$0);
  // Inline function 'kotlin.collections.mapValues' call
  var this_3 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_3.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_3.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$9 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$9);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_4 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = this_4.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(getKClass(GrantTransactionFilters()), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = this_4.decodeFromStringMap_zhdvns_k$(tmp$ret$12, 'filter', encodedParameters);
    this_2.filter_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'textSearch')) {
    var tmp0_0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_7 = tmp0_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_8 = serializer(this_7, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_8, KSerializer()) ? this_8 : THROW_CCE();
    var tmp$ret$14 = tmp0_0.decodeFromStringMap_zhdvns_k$(tmp$ret$15, key, encodedParameters);
    this_2.textSearch_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_2;
}
function AutoRoutes$lambda_43(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'location-rates'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_9()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (LocationRatePage())(tmp$ret$0);
}
function AutoRoutes$lambda_44(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'locations'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_5()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (LocationDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_45(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'placements'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_6()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (ChildPlacementDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_46(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'provider-applications'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_11()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (ProviderApplicationDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_47(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'providers'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_7()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (ProviderDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_48(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'remittances'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (RemittanceDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_49(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'surveys'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_12()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  var this_2 = new (SurveyDetailPage())(tmp$ret$0);
  // Inline function 'kotlin.collections.mapValues' call
  var this_3 = it.parameters_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_3.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_3.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = element.get_value_j01efc_k$();
    var tmp$ret$9 = encodeURIComponent(v);
    destination.put_4fpzoq_k$(tmp, tmp$ret$9);
  }
  var encodedParameters = destination;
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'filter')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_4 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_5 = this_4.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_6 = serializer(this_5, createKType(getKClass(SurveyFilters()), arrayOf([]), false));
    var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
    var tmp$ret$11 = this_4.decodeFromStringMap_zhdvns_k$(tmp$ret$12, 'filter', encodedParameters);
    this_2.filter_1.valueSet_aujvv6_k$(tmp$ret$11);
  }
  if (get_DefaultUriFormat().mapContainsKey_70v9ke_k$(it.parameters_1, 'groupBy')) {
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromStringMap' call
    var this_7 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_8 = this_7.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_9 = serializer(this_8, createKType(getKClass(SurveyGrouping()), arrayOf([]), false));
    var tmp$ret$15 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
    var tmp$ret$14 = this_7.decodeFromStringMap_zhdvns_k$(tmp$ret$15, 'groupBy', encodedParameters);
    this_2.groupBy_1.valueSet_aujvv6_k$(tmp$ret$14);
  }
  return this_2;
}
function AutoRoutes$lambda_50(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 2))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'users'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_13()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$0 = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  // Inline function 'kotlin.apply' call
  return new (UserDetailPage())(tmp$ret$0);
}
function AutoRoutes$lambda_51(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 4))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'providers'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'remittance'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_7()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  var tmp0_0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string_0 = encodeURIComponent(it.segments_1.get_c1px32_k$(3));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(LocalDate()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$3 = tmp0_0.decodeFromString_jwu9sq_k$(tmp$ret$4, string_0);
  // Inline function 'kotlin.apply' call
  return new (RemittanceReviewPage())(tmp, tmp$ret$3);
}
function AutoRoutes$lambda_52(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 3))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'survey'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_12()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  var tmp0_0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string_0 = encodeURIComponent(it.segments_1.get_c1px32_k$(2));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$3 = tmp0_0.decodeFromString_jwu9sq_k$(tmp$ret$4, string_0).raw_1;
  // Inline function 'kotlin.apply' call
  return new (AnonymousSurveyPage())(tmp, tmp$ret$3);
}
function AutoRoutes$lambda_53(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.segments_1.get_size_woubt6_k$() === 4))
    return null;
  if (!(it.segments_1.get_c1px32_k$(0) === 'surveys'))
    return null;
  if (!(it.segments_1.get_c1px32_k$(2) === 'take'))
    return null;
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string = encodeURIComponent(it.segments_1.get_c1px32_k$(1));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_12()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$1, string).raw_1;
  var tmp0_0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.decodeFromString' call
  var string_0 = encodeURIComponent(it.segments_1.get_c1px32_k$(3));
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(Uuid()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$3 = tmp0_0.decodeFromString_jwu9sq_k$(tmp$ret$4, string_0);
  // Inline function 'kotlin.apply' call
  return new (SurveyTakePage())(tmp, tmp$ret$3);
}
function AutoRoutes$lambda_54(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ExcelFormulaLabPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp = listOf('formula-lab');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$5 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$5);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$6);
}
function AutoRoutes$lambda_55(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof NewCareProgramTemplatePage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp = listOf_0(['care-rate-templates', 'new']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$5 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$5);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$6);
}
function AutoRoutes$lambda_56(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof NewCareProgramTemplateDatedPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.templateId_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_8()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_8())(value));
  var tmp = listOf_0(['care-rate-templates', decodeURIComponent(tmp$ret$1), 'versions', 'new']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_57(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof CareProgramTemplatesListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(CareProgramTemplateFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_0()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('care-rate-templates');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_58(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof CareProgramTemplateDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_8()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_8())(value));
  var tmp = listOf_0(['care-rate-templates', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_59(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof LocationRatePage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_9()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_9())(value));
  var tmp = listOf_0(['location-rates', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_60(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof LocationsListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(LocationFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_6()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('locations');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_61(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof LocationDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_5()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_5())(value));
  var tmp = listOf_0(['locations', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_62(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof LandingPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  // Inline function 'kotlin.collections.listOf' call
  var tmp = emptyList();
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$6 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$6);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$7 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$7);
}
function AutoRoutes$lambda_63(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof NotificationListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(NotificationFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sortBy_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_7()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sortBy', tmp2_safe_receiver, params);
  }
  var tmp = listOf('notifications');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sortBy_1]));
}
function AutoRoutes$lambda_64(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof RemittanceTestPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(Condition()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(SingleChildDay()), arrayOf([]), false))]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp = listOf('remit-test');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$10 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$10);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf(it.filter_1));
}
function AutoRoutes$lambda_65(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof CloseOutPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.month_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(YearMonth()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'month', tmp0_safe_receiver, params);
  }
  var tmp = listOf('close-out');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$10 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$10);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf(it.month_1));
}
function AutoRoutes$lambda_66(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ProfilePage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp = listOf('profile');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$5 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$5);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$6);
}
function AutoRoutes$lambda_67(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof UserDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_13()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_13())(value));
  var tmp = listOf_0(['users', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_68(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof UserListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(UserFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_12()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('users');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_69(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof RemittanceDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID())(value));
  var tmp = listOf_0(['remittances', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_70(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof RemittanceReviewPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.provider_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_7()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_7())(value));
  var tmp = decodeURIComponent(tmp$ret$1);
  var tmp0_0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value_0 = it.month_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(LocalDate()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$4 = tmp0_0.encodeToString_k0apqx_k$(tmp$ret$5, value_0);
  var tmp_0 = listOf_0(['providers', tmp, 'remittance', decodeURIComponent(tmp$ret$4)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_1 = element.get_key_18j28a_k$();
    var tmp$ret$11 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_1, tmp$ret$11);
  }
  var tmp_2 = new (UrlLikePath())(tmp_0, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$12 = emptyList();
  return new (RouteRendered())(tmp_2, tmp$ret$12);
}
function AutoRoutes$lambda_71(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof RemittancesListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(RemittanceFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_3 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_4 = this_3.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_5 = serializer(this_4, createKType(getKClass(SortOption_11()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
    this_3.encodeToStringMap_1jy59p_k$(tmp$ret$9, 'sort', tmp1_safe_receiver, params);
  }
  var tmp = listOf('remittances');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$15 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$15);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.sort_1]));
}
function AutoRoutes$lambda_72(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof FamilyApplicationsListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(FamilyApplicationFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_4()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('family-applications');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_73(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ProviderApplicationsListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(ProviderApplicationFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_9()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('provider-applications');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_74(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ProviderApplicationDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_11()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_11())(value));
  var tmp = listOf_0(['provider-applications', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_75(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof FamilyApplicationDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_10()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_10())(value));
  var tmp = listOf_0(['family-applications', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_76(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof EmployersListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(EmployerFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_2()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('employers');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_77(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof EmployerTransactionsPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(EmployerTransactionFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp0_0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_5 = tmp0_0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_6 = serializer(this_5, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
  var tmp$ret$11 = tmp0_0.encodeToString_k0apqx_k$(tmp$ret$12, new (ID_2())(value));
  var tmp = listOf_0(['employers', decodeURIComponent(tmp$ret$11), 'transactions']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$18 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$18);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1]));
}
function AutoRoutes$lambda_78(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof EmployerMonthsPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_2())(value));
  var tmp = listOf_0(['employers', decodeURIComponent(tmp$ret$1), 'months']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_79(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof EmployerCostCalculatorPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp = listOf('employer-cost-calculator');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$5 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$5);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$6);
}
function AutoRoutes$lambda_80(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof EmployerDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_2())(value));
  var tmp = listOf_0(['employers', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_81(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof NewEmployerRatePage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.employerId_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_2())(value));
  var tmp = listOf_0(['employers', decodeURIComponent(tmp$ret$1), 'rates', 'new']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_82(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof HomePage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp = listOf('dashboard');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$5 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$5);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$6);
}
function AutoRoutes$lambda_83(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ChildrenListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(ChildFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_1()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('children');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_84(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ChildDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_1()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_1())(value));
  var tmp = listOf_0(['children', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_85(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ChildPlacementDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_6()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_6())(value));
  var tmp = listOf_0(['placements', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_86(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ChildPlacementsListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(ChildPlacementFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_8()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('placements');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_87(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof NewChildPlacementPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_1()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_1())(value));
  var tmp = listOf_0(['children', decodeURIComponent(tmp$ret$1), 'placements', 'new']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_88(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof AttendancePeriodsListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(AttendancePeriodFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_3 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_4 = this_3.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_5 = serializer(this_4, createKType(getKClass(SortOption()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
    this_3.encodeToStringMap_1jy59p_k$(tmp$ret$9, 'sort', tmp1_safe_receiver, params);
  }
  var tmp = listOf('attendance-periods');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$15 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$15);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.sort_1]));
}
function AutoRoutes$lambda_89(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof AttendancePeriodDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_0()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_0())(value));
  var tmp = listOf_0(['attendance-periods', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_90(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof FamilyDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_3()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_3())(value));
  var tmp = listOf_0(['families', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_91(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof NewFamilyPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp = listOf_0(['families', 'new']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$5 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$5);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$6);
}
function AutoRoutes$lambda_92(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof FamiliesListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(FamilyFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_3()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('families');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_93(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof GrantsListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(GrantFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_5()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('grants');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_94(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof GrantTransactionsPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(GrantTransactionFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp0_0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_5 = tmp0_0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_6 = serializer(this_5, createKType(getKClass(ID_4()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
  var tmp$ret$11 = tmp0_0.encodeToString_k0apqx_k$(tmp$ret$12, new (ID_4())(value));
  var tmp = listOf_0(['grants', decodeURIComponent(tmp$ret$11), 'transactions']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$18 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$18);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1]));
}
function AutoRoutes$lambda_95(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof NewGrantRatePage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.grantId_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_4()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_4())(value));
  var tmp = listOf_0(['grants', decodeURIComponent(tmp$ret$1), 'rates', 'new']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_96(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof GrantDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_4()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_4())(value));
  var tmp = listOf_0(['grants', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_97(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof LoginPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.email_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'email', tmp0_safe_receiver, params);
  }
  var tmp = listOf('login');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$10 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$10);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf(it.email_1));
}
function AutoRoutes$lambda_98(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ProviderDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_7()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_7())(value));
  var tmp = listOf_0(['providers', decodeURIComponent(tmp$ret$1)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$8 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$8);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_99(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ProvidersListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(ProviderFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.textSearch_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'textSearch';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.sort_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_5 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_6 = this_5.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_7 = serializer(this_6, createKType(getKClass(SortOption_10()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
    this_5.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'sort', tmp2_safe_receiver, params);
  }
  var tmp = listOf('providers');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.textSearch_1, it.sort_1]));
}
function AutoRoutes$lambda_100(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof SingleDaysPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(ReportFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp = listOf_0(['reports', 'days']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$10 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$10);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf(it.filter_1));
}
function AutoRoutes$lambda_101(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof BalanceSheetPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.start_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(LocalDate()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'start', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.endInclusive_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_DefaultUriFormat();
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var key = 'endInclusive';
    // Inline function 'kotlinx.serialization.serializer' call
    var this_3 = tmp0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_4 = serializer(this_3, createKType(getKClass(LocalDate()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
    tmp0.encodeToStringMap_1jy59p_k$(tmp$ret$9, key, tmp1_safe_receiver, params);
  }
  var tmp = listOf_0(['reports', 'balances']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$15 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$15);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.start_1, it.endInclusive_1]));
}
function AutoRoutes$lambda_102(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof PlacementTotalsPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(ReportFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.groupBy_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_3 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_4 = this_3.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_5 = serializer(this_4, createKType(getKClass(PlacementGrouping()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
    this_3.encodeToStringMap_1jy59p_k$(tmp$ret$9, 'groupBy', tmp1_safe_receiver, params);
  }
  var tmp2_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.thenBy_1.get_state_wc71uu_k$());
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_6 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_7 = this_6.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_8 = serializer(this_7, createKType(getKClass(PlacementGrouping()), arrayOf([]), false));
    var tmp$ret$14 = isInterface(this_8, KSerializer()) ? this_8 : THROW_CCE();
    this_6.encodeToStringMap_1jy59p_k$(tmp$ret$14, 'thenBy', tmp2_safe_receiver, params);
  }
  var tmp = listOf_0(['reports', 'placement-totals']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$20 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$20);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.groupBy_1, it.thenBy_1]));
}
function AutoRoutes$lambda_103(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof DayTotalsPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(ReportFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.groupBy_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_3 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_4 = this_3.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_5 = serializer(this_4, createKType(getKClass(DayGrouping()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
    this_3.encodeToStringMap_1jy59p_k$(tmp$ret$9, 'groupBy', tmp1_safe_receiver, params);
  }
  var tmp = listOf_0(['reports', 'day-totals']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$15 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$15);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.groupBy_1]));
}
function AutoRoutes$lambda_104(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof AnonymousSurveyPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_12()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_12())(value));
  var tmp = decodeURIComponent(tmp$ret$1);
  var tmp0_0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value_0 = it.employer_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(ID_2()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$4 = tmp0_0.encodeToString_k0apqx_k$(tmp$ret$5, new (ID_2())(value_0));
  var tmp_0 = listOf_0(['survey', tmp, decodeURIComponent(tmp$ret$4)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_1 = element.get_key_18j28a_k$();
    var tmp$ret$11 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_1, tmp$ret$11);
  }
  var tmp_2 = new (UrlLikePath())(tmp_0, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$12 = emptyList();
  return new (RouteRendered())(tmp_2, tmp$ret$12);
}
function AutoRoutes$lambda_105(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof SurveyDetailPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.filter_1.get_state_wc71uu_k$());
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_0 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(SurveyFilters()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
    this_0.encodeToStringMap_1jy59p_k$(tmp$ret$4, 'filter', tmp0_safe_receiver, params);
  }
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.groupBy_1.get_state_wc71uu_k$());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToStringMap' call
    var this_3 = get_DefaultUriFormat();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_4 = this_3.serializersModule_1;
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_5 = serializer(this_4, createKType(getKClass(SurveyGrouping()), arrayOf([]), false));
    var tmp$ret$9 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
    this_3.encodeToStringMap_1jy59p_k$(tmp$ret$9, 'groupBy', tmp1_safe_receiver, params);
  }
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_6 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_7 = serializer(this_6, createKType(getKClass(ID_12()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
  var tmp$ret$11 = tmp0.encodeToString_k0apqx_k$(tmp$ret$12, new (ID_12())(value));
  var tmp = listOf_0(['surveys', decodeURIComponent(tmp$ret$11)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$18 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$18);
  }
  return new (RouteRendered())(new (UrlLikePath())(tmp, destination), listOf_0([it.filter_1, it.groupBy_1]));
}
function AutoRoutes$lambda_106(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof SurveyTakePage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value = it.id_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ID_12()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$1 = tmp0.encodeToString_k0apqx_k$(tmp$ret$2, new (ID_12())(value));
  var tmp = decodeURIComponent(tmp$ret$1);
  var tmp0_0 = get_DefaultUriFormat();
  // Inline function 'com.lightningkite.kotlinx.serialization.uri.encodeToString' call
  var value_0 = it.takerId_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.serializersModule_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(Uuid()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$4 = tmp0_0.encodeToString_k0apqx_k$(tmp$ret$5, value_0);
  var tmp_0 = listOf_0(['surveys', tmp, 'take', decodeURIComponent(tmp$ret$4)]);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_1 = element.get_key_18j28a_k$();
    var tmp$ret$11 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_1, tmp$ret$11);
  }
  var tmp_2 = new (UrlLikePath())(tmp_0, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$12 = emptyList();
  return new (RouteRendered())(tmp_2, tmp$ret$12);
}
function AutoRoutes$lambda_107(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof SurveyListPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp = listOf('surveys');
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$5 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$5);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$6);
}
function AutoRoutes$lambda_108(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof SurveyNewPage()))
    return null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var params = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  var tmp = listOf_0(['surveys', 'new']);
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(params.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = params.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = element.get_key_18j28a_k$();
    var tmp$ret$5 = decodeURIComponent(element.get_value_j01efc_k$());
    destination.put_4fpzoq_k$(tmp_0, tmp$ret$5);
  }
  var tmp_1 = new (UrlLikePath())(tmp, destination);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$6);
}
var properties_initialized_autoroutes_kt_ejo6rf;
function _init_properties_autoroutes_kt__az6i9l() {
  if (!properties_initialized_autoroutes_kt_ejo6rf) {
    properties_initialized_autoroutes_kt_ejo6rf = true;
    var tmp = AutoRoutes$lambda;
    var tmp_0 = AutoRoutes$lambda_0;
    var tmp_1 = AutoRoutes$lambda_1;
    var tmp_2 = AutoRoutes$lambda_2;
    var tmp_3 = AutoRoutes$lambda_3;
    var tmp_4 = AutoRoutes$lambda_4;
    var tmp_5 = AutoRoutes$lambda_5;
    var tmp_6 = AutoRoutes$lambda_6;
    var tmp_7 = AutoRoutes$lambda_7;
    var tmp_8 = AutoRoutes$lambda_8;
    var tmp_9 = AutoRoutes$lambda_9;
    var tmp_10 = AutoRoutes$lambda_10;
    var tmp_11 = AutoRoutes$lambda_11;
    var tmp_12 = AutoRoutes$lambda_12;
    var tmp_13 = AutoRoutes$lambda_13;
    var tmp_14 = AutoRoutes$lambda_14;
    var tmp_15 = AutoRoutes$lambda_15;
    var tmp_16 = AutoRoutes$lambda_16;
    var tmp_17 = AutoRoutes$lambda_17;
    var tmp_18 = AutoRoutes$lambda_18;
    var tmp_19 = AutoRoutes$lambda_19;
    var tmp_20 = AutoRoutes$lambda_20;
    var tmp_21 = AutoRoutes$lambda_21;
    var tmp_22 = AutoRoutes$lambda_22;
    var tmp_23 = AutoRoutes$lambda_23;
    var tmp_24 = AutoRoutes$lambda_24;
    var tmp_25 = AutoRoutes$lambda_25;
    var tmp_26 = AutoRoutes$lambda_26;
    var tmp_27 = AutoRoutes$lambda_27;
    var tmp_28 = AutoRoutes$lambda_28;
    var tmp_29 = AutoRoutes$lambda_29;
    var tmp_30 = AutoRoutes$lambda_30;
    var tmp_31 = AutoRoutes$lambda_31;
    var tmp_32 = AutoRoutes$lambda_32;
    var tmp_33 = AutoRoutes$lambda_33;
    var tmp_34 = AutoRoutes$lambda_34;
    var tmp_35 = AutoRoutes$lambda_35;
    var tmp_36 = AutoRoutes$lambda_36;
    var tmp_37 = AutoRoutes$lambda_37;
    var tmp_38 = AutoRoutes$lambda_38;
    var tmp_39 = AutoRoutes$lambda_39;
    var tmp_40 = AutoRoutes$lambda_40;
    var tmp_41 = AutoRoutes$lambda_41;
    var tmp_42 = AutoRoutes$lambda_42;
    var tmp_43 = AutoRoutes$lambda_43;
    var tmp_44 = AutoRoutes$lambda_44;
    var tmp_45 = AutoRoutes$lambda_45;
    var tmp_46 = AutoRoutes$lambda_46;
    var tmp_47 = AutoRoutes$lambda_47;
    var tmp_48 = AutoRoutes$lambda_48;
    var tmp_49 = AutoRoutes$lambda_49;
    var tmp_50 = AutoRoutes$lambda_50;
    var tmp_51 = AutoRoutes$lambda_51;
    var tmp_52 = AutoRoutes$lambda_52;
    var tmp_53 = listOf_0([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, AutoRoutes$lambda_53]);
    var tmp_54 = getKClass(ExcelFormulaLabPage());
    var tmp_55 = to(tmp_54, AutoRoutes$lambda_54);
    var tmp_56 = getKClass(NewCareProgramTemplatePage());
    var tmp_57 = to(tmp_56, AutoRoutes$lambda_55);
    var tmp_58 = getKClass(NewCareProgramTemplateDatedPage());
    var tmp_59 = to(tmp_58, AutoRoutes$lambda_56);
    var tmp_60 = getKClass(CareProgramTemplatesListPage());
    var tmp_61 = to(tmp_60, AutoRoutes$lambda_57);
    var tmp_62 = getKClass(CareProgramTemplateDetailPage());
    var tmp_63 = to(tmp_62, AutoRoutes$lambda_58);
    var tmp_64 = getKClass(LocationRatePage());
    var tmp_65 = to(tmp_64, AutoRoutes$lambda_59);
    var tmp_66 = getKClass(LocationsListPage());
    var tmp_67 = to(tmp_66, AutoRoutes$lambda_60);
    var tmp_68 = getKClass(LocationDetailPage());
    var tmp_69 = to(tmp_68, AutoRoutes$lambda_61);
    var tmp_70 = getKClass(LandingPage());
    var tmp_71 = to(tmp_70, AutoRoutes$lambda_62);
    var tmp_72 = getKClass(NotificationListPage());
    var tmp_73 = to(tmp_72, AutoRoutes$lambda_63);
    var tmp_74 = getKClass(RemittanceTestPage());
    var tmp_75 = to(tmp_74, AutoRoutes$lambda_64);
    var tmp_76 = getKClass(CloseOutPage());
    var tmp_77 = to(tmp_76, AutoRoutes$lambda_65);
    var tmp_78 = getKClass(ProfilePage());
    var tmp_79 = to(tmp_78, AutoRoutes$lambda_66);
    var tmp_80 = getKClass(UserDetailPage());
    var tmp_81 = to(tmp_80, AutoRoutes$lambda_67);
    var tmp_82 = getKClass(UserListPage());
    var tmp_83 = to(tmp_82, AutoRoutes$lambda_68);
    var tmp_84 = getKClass(RemittanceDetailPage());
    var tmp_85 = to(tmp_84, AutoRoutes$lambda_69);
    var tmp_86 = getKClass(RemittanceReviewPage());
    var tmp_87 = to(tmp_86, AutoRoutes$lambda_70);
    var tmp_88 = getKClass(RemittancesListPage());
    var tmp_89 = to(tmp_88, AutoRoutes$lambda_71);
    var tmp_90 = getKClass(FamilyApplicationsListPage());
    var tmp_91 = to(tmp_90, AutoRoutes$lambda_72);
    var tmp_92 = getKClass(ProviderApplicationsListPage());
    var tmp_93 = to(tmp_92, AutoRoutes$lambda_73);
    var tmp_94 = getKClass(ProviderApplicationDetailPage());
    var tmp_95 = to(tmp_94, AutoRoutes$lambda_74);
    var tmp_96 = getKClass(FamilyApplicationDetailPage());
    var tmp_97 = to(tmp_96, AutoRoutes$lambda_75);
    var tmp_98 = getKClass(EmployersListPage());
    var tmp_99 = to(tmp_98, AutoRoutes$lambda_76);
    var tmp_100 = getKClass(EmployerTransactionsPage());
    var tmp_101 = to(tmp_100, AutoRoutes$lambda_77);
    var tmp_102 = getKClass(EmployerMonthsPage());
    var tmp_103 = to(tmp_102, AutoRoutes$lambda_78);
    var tmp_104 = getKClass(EmployerCostCalculatorPage());
    var tmp_105 = to(tmp_104, AutoRoutes$lambda_79);
    var tmp_106 = getKClass(EmployerDetailPage());
    var tmp_107 = to(tmp_106, AutoRoutes$lambda_80);
    var tmp_108 = getKClass(NewEmployerRatePage());
    var tmp_109 = to(tmp_108, AutoRoutes$lambda_81);
    var tmp_110 = getKClass(HomePage());
    var tmp_111 = to(tmp_110, AutoRoutes$lambda_82);
    var tmp_112 = getKClass(ChildrenListPage());
    var tmp_113 = to(tmp_112, AutoRoutes$lambda_83);
    var tmp_114 = getKClass(ChildDetailPage());
    var tmp_115 = to(tmp_114, AutoRoutes$lambda_84);
    var tmp_116 = getKClass(ChildPlacementDetailPage());
    var tmp_117 = to(tmp_116, AutoRoutes$lambda_85);
    var tmp_118 = getKClass(ChildPlacementsListPage());
    var tmp_119 = to(tmp_118, AutoRoutes$lambda_86);
    var tmp_120 = getKClass(NewChildPlacementPage());
    var tmp_121 = to(tmp_120, AutoRoutes$lambda_87);
    var tmp_122 = getKClass(AttendancePeriodsListPage());
    var tmp_123 = to(tmp_122, AutoRoutes$lambda_88);
    var tmp_124 = getKClass(AttendancePeriodDetailPage());
    var tmp_125 = to(tmp_124, AutoRoutes$lambda_89);
    var tmp_126 = getKClass(FamilyDetailPage());
    var tmp_127 = to(tmp_126, AutoRoutes$lambda_90);
    var tmp_128 = getKClass(NewFamilyPage());
    var tmp_129 = to(tmp_128, AutoRoutes$lambda_91);
    var tmp_130 = getKClass(FamiliesListPage());
    var tmp_131 = to(tmp_130, AutoRoutes$lambda_92);
    var tmp_132 = getKClass(GrantsListPage());
    var tmp_133 = to(tmp_132, AutoRoutes$lambda_93);
    var tmp_134 = getKClass(GrantTransactionsPage());
    var tmp_135 = to(tmp_134, AutoRoutes$lambda_94);
    var tmp_136 = getKClass(NewGrantRatePage());
    var tmp_137 = to(tmp_136, AutoRoutes$lambda_95);
    var tmp_138 = getKClass(GrantDetailPage());
    var tmp_139 = to(tmp_138, AutoRoutes$lambda_96);
    var tmp_140 = getKClass(LoginPage());
    var tmp_141 = to(tmp_140, AutoRoutes$lambda_97);
    var tmp_142 = getKClass(ProviderDetailPage());
    var tmp_143 = to(tmp_142, AutoRoutes$lambda_98);
    var tmp_144 = getKClass(ProvidersListPage());
    var tmp_145 = to(tmp_144, AutoRoutes$lambda_99);
    var tmp_146 = getKClass(SingleDaysPage());
    var tmp_147 = to(tmp_146, AutoRoutes$lambda_100);
    var tmp_148 = getKClass(BalanceSheetPage());
    var tmp_149 = to(tmp_148, AutoRoutes$lambda_101);
    var tmp_150 = getKClass(PlacementTotalsPage());
    var tmp_151 = to(tmp_150, AutoRoutes$lambda_102);
    var tmp_152 = getKClass(DayTotalsPage());
    var tmp_153 = to(tmp_152, AutoRoutes$lambda_103);
    var tmp_154 = getKClass(AnonymousSurveyPage());
    var tmp_155 = to(tmp_154, AutoRoutes$lambda_104);
    var tmp_156 = getKClass(SurveyDetailPage());
    var tmp_157 = to(tmp_156, AutoRoutes$lambda_105);
    var tmp_158 = getKClass(SurveyTakePage());
    var tmp_159 = to(tmp_158, AutoRoutes$lambda_106);
    var tmp_160 = getKClass(SurveyListPage());
    var tmp_161 = to(tmp_160, AutoRoutes$lambda_107);
    var tmp_162 = getKClass(SurveyNewPage());
    AutoRoutes = new (Routes())(tmp_53, mapOf([tmp_55, tmp_57, tmp_59, tmp_61, tmp_63, tmp_65, tmp_67, tmp_69, tmp_71, tmp_73, tmp_75, tmp_77, tmp_79, tmp_81, tmp_83, tmp_85, tmp_87, tmp_89, tmp_91, tmp_93, tmp_95, tmp_97, tmp_99, tmp_101, tmp_103, tmp_105, tmp_107, tmp_109, tmp_111, tmp_113, tmp_115, tmp_117, tmp_119, tmp_121, tmp_123, tmp_125, tmp_127, tmp_129, tmp_131, tmp_133, tmp_135, tmp_137, tmp_139, tmp_141, tmp_143, tmp_145, tmp_147, tmp_149, tmp_151, tmp_153, tmp_155, tmp_157, tmp_159, tmp_161, to(tmp_162, AutoRoutes$lambda_108)]));
  }
}
//region block: exports
export {
  get_AutoRoutes as get_AutoRoutes2trt04tweryz2,
};
//endregion

//# sourceMappingURL=autoroutes.mjs.map
